/**
 * Battlepass BpBillingSite Api
 * Здесь содержатся основные запросы для работы с оплатой на сайте
 */

import MinigamesApi from "@libs/api/MinigamesApi";

class BillingSite extends MinigamesApi {
  constructor() {
    super();
    this.setBaseUrl("/"); // пишем сюда наш базовый URL к API, от которого будут формироваться остальные URLы
  }

  buyOffer(order_id, currency, lang) {
    return this.get("/dynamic/billing/?a=buyitem", {
      itemid: order_id,
      server: currency,
      lang: lang,
    });
  }
}

export default BillingSite;
